import '../../partials/content/faq/faq';
